<template>
    <div class="col-lg-4 dashboard__box-col">
        <div :class="['box ', color]">
            <h2 class="h h--2">Promocja Volex</h2>
            <p>Złotówki to aktualna pula pieniędzy, którą udało Ci się zgromadzić. Sprawdź, czy możesz wymienić je na nagrodę.</p>
            <h3 class="dashboard__points">
                {{ money | moneyDecimal }} <span>zł</span>
            </h3>

            <router-link :to="{name: 'MoneysHistory'}" class="box__link ">&raquo; Historia</router-link>
            <router-link :to="{name: 'Prizes'}" class="button button__bottom">Zamień na nagrody &raquo;</router-link>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'MoneysWidget',
        props: {
            color: {
                default: 'box--blue'
            }
        },
        computed: {
            money() {
                return this.$store.state.user.money
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/app/home/moneys/MoneysWidget.vue